// extracted by mini-css-extract-plugin
export default {"container":"LogoHeader_container__8g5yH","bodyContainer":"LogoHeader_bodyContainer__DkCf-"};